<mat-card class="example-card">
  <mat-card-header class="card-header">
    <mat-card-title class="card-titulo">Búsqueda de {{'Material' | translate}}</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
      <mat-label class="text-style" *ngIf="isValidating"><i class="fa fa-spinner fa-spin"></i> Cargando...</mat-label>
    </div>

    <ng-container *ngIf="canView">

      <mat-expansion-panel *ngIf="!isValidating">

        <mat-expansion-panel-header>
          <mat-panel-title class="card-subtitulo">
            <mat-icon style="margin-top: -3px;">search</mat-icon> Filtros de Búsqueda
          </mat-panel-title>
          <mat-panel-description>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="searchForm">
          <div fxLayout="row stretch" fxLayout.xs="column">
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label class="text-style">Nombre</mat-label>
                <input class="text-style" matInput formControlName="Nombre" (keyup.enter)="onSearch()">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isTipoMaterialSearching">{{'TipoMaterial' | translate}}</mat-label>
                <mat-label *ngIf="isTipoMaterialSearching">Cargando...</mat-label>
                <mat-select formControlName="TipoMaterialId">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of tipoMaterialList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div fxFlex=33.33 fxFlex.xs=100 class="flex-item">
              <mat-form-field appearance="outline" style="width: 100%">
                <mat-label *ngIf="!isUnidadMedidaSearching">{{'UnidadMedida' | translate}}</mat-label>
                <mat-label *ngIf="isUnidadMedidaSearching">Cargando...</mat-label>
                <mat-select formControlName="UnidadMedidaId">
                  <mat-option>Todos</mat-option>
                  <mat-option *ngFor="let s of unidadMedidaList" [value]="s.Id">{{s.Nombre}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          
          </div>
        </form>

        <div fxLayout="row stretch" fxLayout.xs="column">
          <mat-checkbox class="text-style" [(ngModel)]="verSoloActivos" (keyup.enter)="onSearch()" color="primary">Ver
            Solo Activos</mat-checkbox>
        </div>

      </mat-expansion-panel>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px">
        <button mat-raised-button (click)="add()" *ngIf="canAdd" [disabled]="isSearching" color="accent" class="zb-button">Agregar</button>
        <button mat-raised-button (click)="onSearch()" [disabled]="isSearching" color="primary" class="zb-button">{{isSearching ? 'Buscando...' : 'Buscar'}}</button>
        <button mat-raised-button (click)="onExport()" [disabled]="isExporting" color="warn" class="zb-button">{{isExporting ? 'Exportando...' : 'Exportar'}}</button>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" style="margin: 10px 0px;">
        <mat-label *ngIf="isSearching"><i class="fa fa-spinner fa-spin"></i> Buscando...</mat-label>
      </div>

      <div fxLayout="row stretch" fxLayout.xs="column" *ngIf="!isSearching">
        <ejs-grid #grid [dataSource]='data' [query]='query' [allowPaging]="true" [allowSorting]="true"
          [toolbar]='toolbarOptions' [selectionSettings]='selectionOptions' [pageSettings]='pageSettings'
          [allowResizing]='true'>
          <e-columns>
            <e-column field='Nombre' headerText='Nombre' width=90></e-column>
            <e-column field='UnidadMedidaMaterialNombre' headerText='Unidad de Medida' width=90></e-column>
            <e-column field='TipoMaterialNombre' headerText='Tipo de Material' width=90></e-column>
            <e-column field='Activo' headerText='Activo?' width=90>
              <ng-template #template let-data>
                {{data.Activo ? 'Sí' : 'No'}}
              </ng-template>
            </e-column>
            <e-column headerText='Acciones' width=90>
              <ng-template #template let-data>
                <a style="cursor: pointer; margin-right: 5px" (click)="edit(data)"><i class="fa fa-eye fa-1x"></i></a>
              </ng-template>
            </e-column>
          </e-columns>
        </ejs-grid>
      </div>

    </ng-container>

  </mat-card-content>
</mat-card>